import Field from './Field';
import Picker from '../google/Picker';
import { loadPanel } from 'larasnap';
import { isJson } from 'larasnap/support';
import merge from 'lodash-es/merge';
import isObject from 'lodash-es/isObject';

export default class extends Field {
    constructor(element, parent, props) {
        super(
            element,
            parent,
            merge(
                {
                    pickerEnabled: true,
                    pickerRootFolderEnabled: false,
                    pickerFolders: [],
                },
                props,
            ),
        );

        this._fileInput = this.find('input[type=file]');

        this.find('.this-device').click(() => this._fileInput.click());
        this.find('.google-drive').click(this.selectFromDrive.bind(this));
        this.find('.mobile-device').click(this.selectMobileUpload.bind(this));
        this.find('.remove-file').click(this.remove.bind(this));
        this._fileInput.change(this.uploadFileSelected.bind(this));

        this._props.was_uploaded = false;

        this.refresh();
    }

    refresh() {
        if (this.hasFile()) {
            this.find('.edit-mode').hide();
            this.find('.view-mode').show();

            if (this.isEdit()) {
                this.find('.current-file-info').html(this.getFileInfoHtml());
            } else if (this.isView()) {
                this._view.html(this.getFileInfoHtml());
            }
        } else {
            this.find('.edit-mode').show();
            this.find('.view-mode').hide();
        }
    }

    uploadFileSelected() {
        if (this._fileInput.val()) {
            const name = this._fileInput.val().split('\\').pop();
            this.setValue({ name });
        } else {
            this.setValue('');
        }

        this.refresh();
    }

    selectFromDrive() {
        new Picker({
            folders: this._props.pickerFolders,
            root_folder_enabled: this._props.pickerRootFolderEnabled,
            on_select: this.driveFileSelected.bind(this),
        }).show();
    }

    driveFileSelected(file) {
        this.remove();

        this.setValue({
            id: file.id,
            name: file.name,
            url: file.url,
        });

        this.refresh();
    }

    selectMobileUpload() {
        const panel = loadPanel('uploadManager');
        panel.setFileField(this);
    }

    getFileInfoHtml() {
        if (!this.hasFile()) {
            return '';
        }

        const file = this.getValue();

        if (file.url) {
            return `<a target="_blank" href="${file.url}">${file.name}</a>`;
        } else {
            return file.name;
        }
    }

    hasFile() {
        return this.getValue() !== null;
    }

    remove() {
        this.setValue('');
        this._fileInput.val('');
        this.refresh();
    }

    getValue() {
        this._props.was_uploaded =
            this._fileInput.length > 0 && !!this._fileInput.val();

        if (isJson(this._input.val())) {
            return JSON.parse(this._input.val());
        } else {
            return null;
        }
    }

    setValue(value) {
        if (isObject(value)) {
            this._input.val(JSON.stringify(value));
        } else {
            this._input.val('');
        }

        this.refresh();

        return this;
    }
}
